"use client";

/**
 * One muted line under an upload control saying what file works.
 * @returns The hint.
 * @throws Never.
 */
export const AttendeeUploadHint = () => (
  <p className="text-xs font-medium text-gray-600">
    CSV, Excel, PDF or Word with a home city per person. PDF and Word are sent for processing.
  </p>
);
